import { render, staticRenderFns } from "./CredentialConfig.vue?vue&type=template&id=bcc1a8ae&"
import script from "./CredentialConfig.vue?vue&type=script&lang=js&"
export * from "./CredentialConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports